import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { useToast } from '@wartek-id/toast-v2'

import useToggleSdkContext from 'utils/useToogleSdk'
import { useAPIResetPenetapan } from 'api/kinerja/tim-penilai-ps/penetapan'
import { useAuth } from 'utils/auth'

type PenetapanResetButtonProps = {
  pengawasSekolahId: string
}
const PenetapanResetButton = ({
  pengawasSekolahId,
}: PenetapanResetButtonProps) => {
  const toast = useToast()
  const toggle = useToggleSdkContext()
  const { session } = useAuth()

  const toggleEnabled = toggle?.['kinerja-ps-pegawai-reset-enabled'] || false
  const isAccountWhitelisted = Boolean(
    typeof session?.user?.email === 'string' &&
      /@testing\.belajar\.id$/i.test(session?.user?.email)
  )
  const resetable = toggleEnabled || isAccountWhitelisted

  const { mutateAsync: resetPenetapan, isLoading: isMutating } =
    useAPIResetPenetapan({
      pengawasSekolahId,
    })

  const handleReset = React.useCallback(async () => {
    try {
      if (
        confirm(
          `Apakah Anda yakin ingin mereset data Penetapan Predikat Kinerja?`
        )
      ) {
        await resetPenetapan({})
        toast({
          message: `Berhasil mereset data Penetapan Predikat Kinerja`,
          type: 'success',
        })

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    } catch (error) {
      toast({
        message: 'Gagal mereset data Penetapan Predikat Kinerja',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetPenetapan])

  if (!resetable) return null

  return (
    <div className="fixed bottom-0 right-0 z-50 flex gap-2 p-4">
      <Button
        size="sm"
        disabled={isMutating}
        variant="solid"
        color="red"
        onClick={handleReset}
      >
        Reset Penetapan Predikat Kinerja
      </Button>
    </div>
  )
}

export default PenetapanResetButton
